import { Component, OnInit ,Input} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_PM_Duration_Interface, PM_Duration_Interface } from 'src/app/Interface/PM_Duration_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_DurationService } from 'src/app/Service/PM/PM_Duration.service';

@Component({
  selector: 'app-PMDurationForm',
  templateUrl: './PMDurationForm.component.html',
  styleUrls: ['./PMDurationForm.component.css']
})
export class PMDurationFormComponent implements OnInit {

  @Input() inner_PM: PM_Duration_Interface = Empty_PM_Duration_Interface()




  constructor(
    private PM_Duration_Service: PM_DurationService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {

    this.PMForm = new FormGroup({
      id: new FormControl(),
      Title: new FormControl(null, Validators.required),
      Duration: new FormControl(null, Validators.required),
    })

    this.Nav_Service.CheckValidPage(1158).subscribe(
      data => {
        this.get_Form_Title().setValue(this.inner_PM.title)
        this.get_Form_Duration().setValue(this.inner_PM.duration)
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }


  //#region  Form

  PMForm: FormGroup;

  get_Form_Title() {
    return this.PMForm.get('Title') as FormControl;
  }

  get_Form_Duration() {
    return this.PMForm.get('Duration') as FormControl;
  }

  //#endregion

  InProccessing: boolean = false

  SubmitPMForm() {
    var Record: PM_Duration_Interface = Empty_PM_Duration_Interface()
    Record.id = this.inner_PM.id
    Record.title = this.get_Form_Title().value
    Record.duration = Number(this.get_Form_Duration().value)

    if (Record.duration < 1) {
      this.Alertify_Service.ErrorMessage("مقدار روز را بررسی نمائید")
    }
    else {
      this.InProccessing = true
      this.PM_Duration_Service.AddEditPM(Record).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("عنوان وارد شده در سامانه ثبت شده است")
          }
          else {

            this.inner_PM.id = data.id
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
    }

  }


}
